// The list endpoints (/sketches/all and /sketches/list) do not send `code` --
// it was 91% of a 42 MB response. So a sketch picked out of the gallery has a
// name and a thumbnail but no body, and GET /sketches/:id is the only place to
// get one.
//
// That matters because the editor renders `sketch.code || emptyCode`, which
// makes a bodyless sketch look like an empty pattern rather than a broken one.
// Nothing noticed until the firmware builder was handed the string "undefined"
// where a draw() was meant to be.
//
// fetchSketch is passed in rather than imported so this stays a plain function:
// callers hold the network container, this does not.
export const hydrateSketches = async (sketches, fetchSketch) =>
  Promise.all(
    sketches.map((sketch) =>
      // No id means an unsaved editor tab, which has nothing to fetch by. Code
      // that is present but empty is a legitimately empty pattern.
      sketch && sketch.id && sketch.code == null
        ? fetchSketch(sketch.id)
        : sketch
    )
  );
